export function textContains(text, query, sensitivity = "base") {
  if (!query) {
    return true;
  }
  if (sensitivity === "case") {
    return text.includes(query);
  }
  const collator = new Intl.Collator(void 0, {
    sensitivity: sensitivity === "accent" ? "accent" : "base",
    usage: "search"
  });
  for (let index = 0; index <= text.length - query.length; index += 1) {
    const slice = text.slice(index, index + query.length);
    if (collator.compare(slice, query) === 0) {
      return true;
    }
  }
  return false;
}